import assert from '@/sui/tools/assert'
import rtti from '@/sui/tools/rtti'
import checker from '@/sui/tools/checker'
import units from '@/sui/data/units'

import go from '@/gojs/go'

import clone from 'clone'

const adm = { key: 'adm', title: 'Admissions' }
const file = { key: 'file', title: 'File active moyenne' }
const jh = { key: 'jh', title: `Journées d'hospitalisation complètes` }

const sea = { key: 'sea', title: 'Séances de dialyse', nr: false }
const seaNr = { key: 'sea', title: 'Séances de dialyse', nr: true }

const chi = { key: 'chi', title: 'Séances de chimiothérapie', nr: true }
const ven = { key: 'ven', title: `Journées d'hospitalisation incomplètes`, nr: true }
const jhi = { key: 'jhi', title: `Journées d'hospitalisation incomplètes`, nr: true }

const bed = { key: 'bed', title: 'Lits surveillés' }
const bedWE = clone(bed)
bedWE.edit = (n, o, data, columns) => {
  if (n !== '0') {
    return
  }

  for (let i = 0; i !== columns.length; ++i) {
    const c = columns[i]
    if (c.value == null && c.key !== 'bed') {
      data[c.key] = 0
    }
  }
}

const specialities = go.units.specialities
const disciplines = go.units.disciplines

const reaCodes = [
  disciplines.AdRea.code,
  disciplines.NeoRea.code,
  disciplines.PedRea.code,
  disciplines.MixRea.code
]

const adPedMedCodes = [
  disciplines.AdMed.code,
  disciplines.AdCan.code,
  disciplines.AdRad.code,
  disciplines.AdHem.code,
  disciplines.PedMed.code,
  disciplines.PedCan.code
]

const diaCodesV1 = [
  disciplines.AdDia.code,
  disciplines.PedDia.code
]

const diaCodesV2 = [
  ...diaCodesV1,
  specialities.AdDiaHdc.code,
  specialities.AdDiaUdm.code,
  specialities.AdDiaUad.code,
  specialities.AdDiaDom.code
]

const hadCodes = [
  disciplines.AdHad.code,
  disciplines.PedHad.code
]

const nepCode = [specialities.AdMedNep.code]
const urgCodes = [
  disciplines.AdUrg.code,
  disciplines.PedUrg.code,
  disciplines.NeoUrg.code
]
const ssrCodes = [
  disciplines.AdSsr.code,
  disciplines.PedSsr.code
]
const psyCodes = [
  disciplines.AdPsy.code,
  disciplines.PedPsy.code
]
const sldCodes = [
  disciplines.AdSld.code,
  disciplines.PedSld.code
]

const denominatorListsAndTypes = {
  v1: [
    {
      codes: [
        ...adPedMedCodes,
        disciplines.AdObs.code,
        disciplines.AdChir.code,
        disciplines.PedChir.code,
        disciplines.NeoChir.code
      ],
      denominators: [bedWE, adm, jh, jhi],
      type: 1
    },
    {
      codes: [
        ...reaCodes,
        disciplines.NeoMed.code,
        ...urgCodes,
        ...ssrCodes,
        ...psyCodes,
        ...sldCodes,
        disciplines.AdEhp.code
      ],
      denominators: [bedWE, adm, jh],
      type: 2
    },
    { codes: hadCodes, denominators: [file, jh], type: 3 },
    { codes: nepCode, denominators: [bedWE, adm, jh, jhi, seaNr], type: 4 },
    { codes: diaCodesV1, denominators: [bedWE, adm, sea], type: 5 }
  ],

  v2: [
    {
      codes: [
        ...adPedMedCodes,
        disciplines.AdObs.code
      ],
      denominators: [bedWE, adm, jh, jhi, chi],
      type: 1
    },
    {
      codes: [
        ...reaCodes,
        disciplines.NeoMed.code,
        ...urgCodes,
        ...ssrCodes,
        ...psyCodes,
        ...sldCodes,
        disciplines.AdEhp.code
      ],
      denominators: [bedWE, adm, jh, chi],
      type: 2
    },
    { codes: hadCodes, denominators: [file, jh, chi], type: 3 },
    { codes: nepCode, denominators: [bedWE, adm, jh, jhi, seaNr, chi], type: 4 },
    { codes: diaCodesV1, denominators: [bedWE, adm, sea, chi], type: 5 },
    {
      codes: [
        disciplines.AdChir.code,
        disciplines.PedChir.code,
        disciplines.NeoChir.code
      ],
      denominators: [bedWE, adm, jh, ven, chi],
      type: 6
    }
  ],

  v3: [
    {
      codes: [
        ...reaCodes,
        ...urgCodes,
        ...ssrCodes,
        ...psyCodes,
        ...sldCodes,
        disciplines.AdEhp.code,
        disciplines.NeoMed.code
      ],
      denominators: [bed, adm, jh],
      type: 1
    },
    {
      codes: [
        disciplines.NeoChir.code,
        disciplines.AdObs.code
      ],
      denominators: [bed, adm, jh, jhi],
      type: 2
    },
    {
      codes: [
        ...adPedMedCodes,
        disciplines.AdChir.code,
        disciplines.PedChir.code
      ],
      denominators: [bed, adm, jh, jhi, chi],
      type: 3
    },
    { codes: nepCode, denominators: [bed, adm, jh, jhi, chi, seaNr], type: 4 },
    { codes: diaCodesV2, denominators: [bed, adm, sea], type: 5 },
    { codes: hadCodes, denominators: [file, jh], type: 6 }
  ]
}

function getDenominatorsAndTypeImplementation (list, unitType) {
  const [discipline, speciality] = go.units.getIncidenceDisciplineAndSpeciality(unitType)
  assert.notNull(discipline)

  let result = null
  for (let i = 0; i !== list.length; ++i) {
    const entry = list[i]
    const codes = entry.codes

    if (speciality != null) {
      if (codes.includes(speciality.Code)) {
        return entry
      }
    }

    if (codes.includes(discipline.Code)) {
      assert.isNull(result)
      result = entry
    }
  }

  assert.notNull(
    result,
    `${discipline.Code}/${speciality != null ? speciality.Code : '__all__'} has no denominators and type`
  )
  return result
}

const denominatorsAndTypesByYear = {
  '2020': denominatorListsAndTypes.v1,
  '2021': denominatorListsAndTypes.v2,
  '2022': denominatorListsAndTypes.v2,
  '2023': denominatorListsAndTypes.v2,
  '2024': denominatorListsAndTypes.v3,
  '2025': denominatorListsAndTypes.v3,
  '2026': denominatorListsAndTypes.v3
}

function checkListAndTypes (c) {
  const allowedList = [ adm, file, jh, sea, seaNr, chi, ven, jhi, bed, bedWE ]

  for (let i = 0; i !== allowedList.length; ++i) {
    const denominator = allowedList[i]
    c.checkSchema(
      'allowedDenominators',
      denominator,
      [
        { key: 'key', req: true, type: 'str' },
        { key: 'title', req: true, type: 'str' },
        { key: 'nr', req: false, type: 'bool' },
        { key: 'edit', req: false, type: 'func' }
      ]
    )
  }

  const allowedDenominators = new Set(allowedList)
  for (let v in denominatorListsAndTypes) {
    const entries = denominatorListsAndTypes[v]
    const codes = new Set()
    for (let i = 0; i !== entries.length; ++i) {
      const entry = entries[i]
      c.checkSchema(
        'denominatorListsAndTypes',
        entry,
        [
          { key: 'codes', req: true, type: 'array' },
          { key: 'denominators', req: true, type: 'array' },
          { key: 'type', req: true, type: 'int' }
        ]
      )

      for (let j = 0; j !== entry.codes.length; ++j) {
        const code = entry.codes[j]
        c.check(
          rtti.isString(code),
          `Invalid type for code ${code}-${j}-${i}-${v}`
        )
        c.check(
          !codes.has(code),
          `Duplicate code ${code} in denominators list ${j}-${i}-${v}`
        )
        codes.add(code)
      }

      for (let j = 0; j !== entry.denominators.length; ++j) {
        const denominator = entry.denominators[j]
        c.check(
          allowedDenominators.has(denominator),
          `Denominator «${denominator.key}» (denominatorListAndTypes.${v}[${i}].denominators[${j}])
is not in the allowed list.`
        )
      }
    }
  }
}

function checkYearlyListAndTypes (c) {
  for (let year in denominatorsAndTypesByYear) {
    const listAndTypes = denominatorsAndTypesByYear[year]
    const yearSpecialities = units[year].specialities
    const yearCodes = new Set()
    for (let id in yearSpecialities) {
      const speciality = yearSpecialities[id]
      const index = speciality.index
      yearCodes.add(speciality.code)
      try {
        getDenominatorsAndTypeImplementation(listAndTypes, index)
      } catch (e) {
        c.check(false, e)
      }
    }

    for (let i = 0; i !== listAndTypes.length; ++i) {
      const entry = listAndTypes[i]
      for (let j = 0; j !== entry.codes.length; ++j) {
        const code = entry.codes[j]
        c.check(
          yearCodes.has(code),
          `Invalid code «${code}» (${year}, ${i}, ${j})`
        )
      }
    }
  }
}

if (process.env.VUE_APP_SPIADI_DEBUG === '1') {
  const c = checker('@/sui/data/denominators')
  checkListAndTypes(c)
  checkYearlyListAndTypes(c)
  c.end()
}

export default {
  getDenominatorsAndType: function (year, ut) {
    const list = denominatorsAndTypesByYear[year]
    assert.notNull(list, `getDenominatorsAndType: Missing year ${year}`)
    return getDenominatorsAndTypeImplementation(list, ut)
  }
}
